module.exports = __webpack_public_path__ + "signup_step_lollipop_3.90bf813aadc75ba4b6484b3f50477ff7.jpg";